import { TESTS_PAGE_STATUSES } from './../../constants';
import { TestCaseRecord } from './../../records';

/**
 *
 * @param {Object} testCase
 * @param {Object} testCase.statuses
 * @param {number} testCase.total_runs
 * @returns {number}
 */
export const getPassedRate = ({ statuses, total_runs: totalRuns }) => (
  Number.isFinite(statuses?.passed) && totalRuns ? (statuses.passed * 100) / totalRuns : 0
);

/**
 *
 * @param {Object[]} testCases
 * @param {string} status
 * @returns {Immutable.Record[]}
 */
export const filterTestCases = (testCases, status) => {
  let items = testCases;
  if (status === TESTS_PAGE_STATUSES.inconsistent.status) {
    items = testCases.filter(({ statuses }) => Object.keys(statuses).length > 1);
  }

  return items.map((testCase) => new TestCaseRecord({
    ...testCase,
    pass_rate: getPassedRate(testCase),
  }));
};

const sortStrings = (prev, curr) => prev.localeCompare(curr);
const sortNumbers = (prev, curr) => curr - prev;

/**
 *
 * @param {Immutable.Map[]|Immutable.Record[]} testCases
 * @param {string} sortFieldName
 * @param {boolean} direction
 * @returns {Immutable.Map[]|Immutable.Record[]}
 */
export const sortTestCases = (testCases, sortFieldName, direction) => (
  testCases.sort((prev, curr) => {
    const prevField = prev.get(sortFieldName);
    const currField = curr.get(sortFieldName);
    const areNumbers = Number.isFinite(prevField) && Number.isFinite(currField);
    const sortFn = areNumbers ? sortNumbers : sortStrings;

    if (direction) {
      return sortFn(prevField, currField);
    }
    return sortFn(currField, prevField);
  })
);
